module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "book"
  }, _vm._l((_vm.page), function(item) {
    return _c('ChessInfo', {
      key: item.id,
      attrs: {
        "chess-sgf": item
      },
      nativeOn: {
        "click": function($event) {
          _vm.$router.push({
            name: 'question',
            params: {
              id: item.chess_sgf.id,
              chessSgf: item
            }
          })
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('router-link', {
    attrs: {
      "to": {
        query: {
          page: Math.max(1, _vm.pageNum - 1)
        }
      },
      "replace": ""
    }
  }, [_vm._v("<上一页")]), _vm._v(" "), _c('span', [_vm._v(" | ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        query: {
          page: _vm.pageNum + 1
        }
      },
      "replace": ""
    }
  }, [_vm._v("下一页>")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/猜谱.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("猜谱")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-fd5e6090"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/Books.vue
// module id = 214
// module chunks = 2